import React from 'react';

import { Icons, type DomainKey } from '@shared/components/ui';

import { domainHoverProps } from './domainHover';
import SideNavRowContent from './SideNavRowContent';
import { sideNavRowShellClasses } from './sideNavRowShellClasses';

interface SideNavRowButtonProps {
  isCollapsed: boolean;
  icon: keyof typeof Icons;
  /** When set, render the duotone domain-colored icon. */
  domain?: DomainKey;
  label: string;
  active?: boolean;
  /** Caller's base text color when not active (e.g. 'text-sidebar-foreground'). */
  inactiveText?: string;
  /** Caller's hover class (e.g. 'hover:bg-sidebar-accent'). */
  hover?: string;
  /** Accessible name for the icon-only collapsed row (the visible label is hidden). */
  ariaLabel?: string;
  trailing?: React.ReactNode;
  collapsedBadge?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  onContextMenu?: (e: React.MouseEvent) => void;
}

/** A single-interactive-element nav row rendered as a button. Shell classes sit on the button itself. */
const SideNavRowButton: React.FC<SideNavRowButtonProps> = ({
  isCollapsed,
  icon,
  domain,
  label,
  active = false,
  inactiveText,
  hover = '',
  ariaLabel,
  trailing,
  collapsedBadge,
  onClick,
  onContextMenu,
}) => {
  const dh = domainHoverProps(domain);
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      onContextMenu={onContextMenu}
      {...(dh.style ? { style: dh.style } : {})}
      className={`${sideNavRowShellClasses({ active, ...(inactiveText ? { inactiveText } : {}) })} ${dh.className} ${hover} w-full cursor-pointer px-3 py-1 text-xs font-medium transition-colors`}
    >
      <SideNavRowContent
        isCollapsed={isCollapsed}
        icon={icon}
        {...(domain ? { domain } : {})}
        label={label}
        trailing={trailing}
        collapsedBadge={collapsedBadge}
      />
    </button>
  );
};

export default SideNavRowButton;
